// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bulkApproveModal p {
  margin-bottom: 0.64rem;
}
#bulkApproveModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#bulkApproveModal .btn-secondary {
  border-radius: 30px;
  min-width: 115px;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#bulkApproveModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
@media (min-width: 2024px) {
#bulkApproveModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#bulkApproveModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
